import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { AppLayout } from './components/layout/AppLayout';
import { Button } from './components/ui/Button';
import { StateBlock } from './components/ui/Feedback';
import { LoginPage } from './features/auth/LoginPage';
import { RequireAuth } from './features/auth/RequireAuth';
import { RfpListPage } from './features/rfp/RfpListPage';
import { AddRfpPage } from './features/rfp/AddRfpPage';
import { RfpDetailPage } from './features/rfp/RfpDetailPage';
import { VendorMasterPage } from './features/vendor/VendorMasterPage';

function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <AppLayout title="RFP">
      <StateBlock
        title="Page not found"
        description="The screen you were looking for does not exist."
        action={
          <Button variant="primary" onClick={() => navigate('/rfp')}>
            Back to RFP list
          </Button>
        }
      />
    </AppLayout>
  );
}

export function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<LoginPage />} />

      {/* Everything below needs a session; RequireAuth redirects to /login. */}
      <Route element={<RequireAuth />}>
        <Route path="/" element={<Navigate to="/rfp" replace />} />
        <Route path="/rfp" element={<RfpListPage />} />
        <Route path="/rfp/new" element={<AddRfpPage />} />
        <Route path="/rfp/:id" element={<RfpDetailPage />} />
        <Route path="/vendor-master" element={<VendorMasterPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
